import { TMDBMovie, TMDBTVShow, getTMDBImageUrl } from "../../hooks/tmdb";

// Helper function to transform TMDB movie/TV show to CarouselItem
export const transformTMDBItem = (item: TMDBMovie | TMDBTVShow) => {
  const title = item.title || item.name || "Untitled";
  const image =
    getTMDBImageUrl(item.backdrop_path, "w342") ||
    getTMDBImageUrl(item.poster_path, "w342") ||
    "";

  return {
    id: item.id.toString(),
    image,
    title,
  };
};
